<template>
	<section
		:class="['remove-margin', 'global-search-stories', {'hide-result-content' : hideByDefault}]"
		v-if="offers?.length > 0"
	>
		<article
			class="global-search-single-story-container" v-for="offer in getFirstThreeOffers"
			:key="offer.id"
		>
					<span
						class="global-search-result-title"
						@click="openOffer(offer)"
						v-html="isTitleAndMatchTextCombined ? getOfferTitle(offer) : markKeyWord(getOfferTitle(offer))">
					</span>

			<p
				class="global-search-result-text"
				@click="openOffer(offer)"
				v-if="offer && (isTitleAndMatchTextCombined || !getOfferTitle(offer).toLowerCase().includes($store.getters.getGlobalSearchResult('word').toLowerCase()))"
				v-html="modifyText(getText(offer), 100)">
			</p>

		</article>
		<button v-if="offers.length >= 2 && !hideShowAllButton" class="show-all" @click="viewAll()">
			{{ `${$t('globalSearchSections.showAll')} (${offers.length})` }}
		</button>
	</section>
</template>

<script>
import {LANGUAGE_ARRAY} from "@/common/utils/constants";

export default {
	name: "GlobalSearchSingleOfferResult",
	props: {
		offers: {
			type: Array,
			required: true
		},
		hideByDefault: {
			type: Boolean,
			required: false,
			default: true
		},
		hideShowAllButton: {
			type: Boolean,
			required: false,
			default: false
		},
		showNumberOfOffers: {
			type: Number,
			required: false,
			default: 3
		},
		isTitleAndMatchTextCombined: {
			type: Boolean,
			required: false,
			default: true
		}
	},
	computed: {
		getFirstThreeOffers() {

			return this.offers.length > this.showNumberOfOffers ? this.offers.slice(0, this.showNumberOfOffers) : this.offers;
		}
	},
	methods: {
		getText(offer){
			const word = this.$store.getters.getGlobalSearchResult('word').toUpperCase().trim();
			const translation = offer?.translations.find(translation => LANGUAGE_ARRAY.find(lang => lang.id === translation.languageId));
			let text = null;
			Object.keys(translation).forEach((field) => {
				const translationText = translation[field] ? translation[field] : null;
				if (!text && translationText && `${translationText}`.toUpperCase().trim().includes(word)) {
					text = translationText;
				}
			})

			return text;
		},
		getOfferTitle() {
			return this.offer?.translations.find(translation => LANGUAGE_ARRAY.find(lang => lang.id === translation.languageId)).title;
		},
		viewAll() {
			const language = LANGUAGE_ARRAY.find(lang => lang.short === this.$i18n.locale)
			const url = `/gop/search?text=${this.$store.getters.getGlobalSearchResult('word')}&format=GRID&contentLanguageId=${language.id}`
			this.$router.push(url);
		},
		modifyText(text, numSymbols) {
			let index = `${text}`?.toLowerCase().indexOf(this.$store.getters.getGlobalSearchResult('word').toLowerCase());
			let startIndex = 0;
			let charactersCount = index + numSymbols

			if (index > numSymbols) {
				startIndex = index - numSymbols
				charactersCount = numSymbols * 2
			}

			if (text?.length < numSymbols) {
				text = "..." + `${text}` + "..."
			} else {
				text = "..." + `${text}`.substr((startIndex - 1) + this.$store.getters.getGlobalSearchResult('word').length, charactersCount) + "...";
			}

			text = this.replaceUnquotedTags(text);

			return this.markKeyWord(text);
		},
		replaceUnquotedTags(text) {
			const regex = /\.\.\.(p|h1|h2|h3|div|ul|li|l|i|1|2|3|v|iv)>/gi;
			text = text.replace(regex, '...');

			return text;
		},
		modifyTextIfThereAreSpecialCharacters(text) {
			let isSpecialCharacter = text.includes('.') || text.includes('+') || text.includes('*') || text.includes('?')
				|| text.includes('^') || text.includes('$') || text.includes('(') || text.includes(')')
				|| text.includes('[') || text.includes(']') || text.includes('{') || text.includes('}')
				|| text.includes('|') || text.includes('\\');

			return isSpecialCharacter ? "\\" + text : text;
		},
		markKeyWord(text) {
			let word = this.modifyTextIfThereAreSpecialCharacters(this.$store.getters.getGlobalSearchResult('word'));
			let pattern = new RegExp(word, 'i');
			let result = pattern.exec(text);
			return text?.replaceAll(result, `<b class="keyword">${result}</b>`)
		},
		openOffer(offer) {
			let pdfUrl = `/gop/offers/${offer.id}`
			window.open(pdfUrl, '_blank');
		},
	}
}
</script>
